import { makeStyles } from "@material-ui/core";
import { remCalc } from "../../utils/helpers";

export const useImportStyles = makeStyles(theme => ({
  root: {
    minHeight: "100%"
    // backgroundColor: "#F7F7F7"
  },
  header: {
    height: 80,
    borderBottom: theme.variables.border,
    backgroundColor: "#fff",
    boxSizing: "border-box"
  },
  title: {
    fontWeight: 500,
    fontSize: "1.25rem",
    lineHeight: "1.4375rem"
  },
  body: {
    maxHeight: "calc(100vh - 80px)",
    overflowY: "auto",
    boxSizing: "border-box"
  },
  backButton: {
    marginRight: theme.spacing(3)
  },
  section: {
    backgroundColor: "#fff",
    // borderTop: theme.variables.border,
    borderBottom: theme.variables.border
  },
  panelSummary: {
    "& .MuiExpansionPanelSummary-expandIcon": {
      alignSelf: "start"
    }
  },
  chip: {
    height: remCalc(28),
    color: "#7D7E82",
    fontSize: remCalc(14),
    backgroundColor: "#F7f7f7",
    marginRight: theme.spacing(1),
    marginTop: theme.spacing(1)
  },
  chipDark: {
    color: "#fff",
    backgroundColor: "#7D7E82"
  },
  btn: {
    textTransform: "none",
    padding: theme.spacing(1.125, 3),
    fontSize: "0.9375rem",
    lineHeight: "1.125rem",
    minWidth: 0
  }
}));
